"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loader = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _Loader = require("./Loader.styles");
var _excluded = ["className", "withOverlay", "testId"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Loader = function Loader(props) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    withOverlay = props.withOverlay,
    _props$testId = props.testId,
    testId = _props$testId === void 0 ? 'loader' : _props$testId,
    rest = _objectWithoutProperties(props, _excluded);
  var _useStyles = (0, _Loader.useStyles)(),
    root = _useStyles.root,
    overlay = _useStyles.overlay;
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": testId,
    className: (0, _classnames["default"])(root, className, _defineProperty({}, overlay, withOverlay))
  }, /*#__PURE__*/_react["default"].createElement(_core.CircularProgress, _extends({
    color: "inherit"
  }, rest)));
};
exports.Loader = Loader;